import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/cn";

const badgeVariants = cva(
  "inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-border px-2.5 py-0.5 text-xs transition-colors",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground font-semibold shadow-sm hover:bg-primary/80",
        secondary:
          "border-transparent bg-muted text-accent-foreground font-semibold hover:bg-muted/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground font-semibold shadow-sm hover:bg-destructive/80",
        outline: "text-foreground font-normal",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
